module.exports = __webpack_public_path__ + "img/image8.9f27d954.png";